import { Scope } from '@toeverything/infra';

export class ViewScope<View> extends Scope<{
  view: View;
}> {}
